module.exports = __webpack_public_path__ + "img/20220809161701.3ea0cc86.jpg";